/**
 * Web Style Import
 *
 */

import './style/dnb-input.scss'
